import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "antd/lib/card";
import Select from "antd/lib/select";

import { IconMapPin, IconRobot } from "@tabler/icons-react";

import styles from "./region-selection-card.module.css";

const { Option } = Select;

export default function RegionSelectCard({ handleGenerateAll, selectedRegions, handleRegionSelect, loading, regions }) {
    return (
    <Card className={styles.selectionCard}>
        <div className={styles.cardHeader}>
          <div className={styles.cardHeaderLeft}>
            <IconMapPin size={24} className={styles.cardIcon} />
            <div>
              <Typography variant="h6">Select Regions</Typography>
              <Typography variant="body2" color="textSecondary">
                Choose the regions to send storm strategies
              </Typography>
            </div>
          </div>
          <Button
            variant="contained"
            onClick={handleGenerateAll}
            startIcon={<IconRobot size={20} />}
            className={styles.generateAllButton}
            disabled={selectedRegions.length === 0}
          >
            Generate All Messages
          </Button>
        </div>
        <Select
          mode="multiple"
          placeholder="Select regions to manage"
          style={{ width: '100%', marginTop: '16px' }}
          value={selectedRegions}
          onChange={handleRegionSelect}
          loading={loading.regions}
        >
          {regions.map((region) => (
            <Option key={region} value={region}>
              {region}
            </Option>
          ))}
        </Select>
      </Card>
    )
}